export default {
	label: "Toronto",
	value: "YYZ",
};
